import { Api } from "../../api/Api";
import { BooleanThunk } from "../IStore";
import { reloadCustomerHistory } from "./HistoryActions";
import { thunkCreateErrorNotification, thunkCreateSuccessNotification } from "./NotificationActions";
import { ReplacementIdentifactionDto } from "../models/identification/ReplacementIdentifactionDto";

export const thunkReplaceIdentifications =
  (customerNumber: string, replaceIdentificcationDto: ReplacementIdentifactionDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.replaceIdentifications(customerNumber, replaceIdentificcationDto);
      reloadCustomerHistory(dispatch, customerNumber);
      dispatch(thunkCreateSuccessNotification("Ersatzkartenanfrage erfolgreich gesendet"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to send replacement card request", e));
      return false;
    }
  };
